import React from 'react';
import { Handle, Position } from 'reactflow';

class NodeInitial extends React.Component {
  render() {
    return (
      <>
        <div className="dndnode input">
          {this.props.data.label}
        </div>
        <Handle type="source" position={Position.Bottom} />
      </>
    );
  }
}

export default NodeInitial;
